/**
 * Build Info Loader (Client-side)
 *
 * Fetches /BUILD_INFO.json (deployed by CI with no-cache headers).
 * Falls back to REACT_APP_VERSION or 'dev' for local development.
 */

import { logger } from './logger';

export interface BuildInfo {
  version: string;
  sha: string;
  sha_short: string;
  ref: string;
  build_time: string | null;
  build_number: string | null;
}

const DEV_BUILD_INFO: BuildInfo = {
  version: process.env.REACT_APP_VERSION || 'dev',
  sha: 'dev',
  sha_short: 'dev',
  ref: 'local',
  build_time: null,
  build_number: null
};

let _buildInfo: BuildInfo | null = null;

export async function loadBuildInfo(): Promise<BuildInfo> {
  if (_buildInfo) return _buildInfo;

  try {
    const res = await fetch('/BUILD_INFO.json');
    if (res.ok) {
      const data = await res.json();
      if (typeof data === 'object' && data !== null && 'version' in data) {
        const info: BuildInfo = { ...DEV_BUILD_INFO, ...data };
        _buildInfo = info;
        logger.info('[BuildInfo] Loaded:', { version: info.version, sha: info.sha_short });
        return info;
      }
    }
  } catch {
    // Local dev — no BUILD_INFO.json served
  }

  _buildInfo = DEV_BUILD_INFO;
  return _buildInfo;
}

export function getBuildInfo(): BuildInfo {
  return _buildInfo || DEV_BUILD_INFO;
}
